const routes = [
  {
    path: "/mealplanner",
    name: "MealPlanner",
    component: () =>
      import(
        /* webpackChunkName: "mymessages" */ "@/pages/MealPlanner/MealPlannerIndex"
      ),
    meta: {
      title: "Meal Planner - NutriBit",
      showSearch: false
    }
  }
];

export default routes;
